import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestExecutor } from '../../libraries/request-executor/request-executor';
import { ConversationId } from '../../libraries/conversation-id/conversation-id';
import { LocaleHandler } from '../../libraries/locale-handler/locale-handler';
import { Constants } from '../../constants';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService extends RequestExecutor {
  /**
   * Translations object
   * @var {object}
   */
  private _translations: object = {};

  /**
   * Class constructor
   *
   * @param _localeHandler
   * @param _conversationId
   * @param _httpClient
   */
  constructor(
    protected _localeHandler: LocaleHandler,
    protected _conversationId: ConversationId,
    protected _httpClient: HttpClient
  ) {
    super(_conversationId, _httpClient);
  }

  /**
   * Return the loaded translations object
   *
   * @returns {object}
   */
  public getTranslations(): object {
    return this._translations;
  }

  /**
   * Loads the translations from the API endpoint based on the current locale
   *
   * @returns {Promise<any>}
   */
  public loadTranslations(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.setRequestHeaders({}, true).setRequestParams({
        'locale': this._localeHandler.getCurrentLocale()
      })
        .executeRequest(
          Constants.REQUEST_TYPE_GET,
          `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.translate}`
        )
        .subscribe(
          (translations: any) => {
            this._translations = translations;
            resolve(translations);
          },
          (error: any) => {
            reject(error);
          }
        );
    });
  }
}
